import { Injectable } from "@angular/core";
import { AngularFirestore, QueryDocumentSnapshot, DocumentData, DocumentReference } from '@angular/fire/firestore';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { PractitionerStatus } from "../enums/practitioner-status.enum";
import { Practitioner } from "../models/practitioner.model";
import { Status } from "../models/status.model";
import { MailService } from "./mail.service";

@Injectable()
export class StatusService {

  constructor(private firestore: AngularFirestore, private mailService: MailService){}

  getStatuses(practitionerId: string): Observable<Status[]> {
    return this.firestore.collection('practitioners').doc(practitionerId).collection('statuses').get()
      .pipe(map(query => {
        var statuses: Status[] = [];
        query.forEach((document: QueryDocumentSnapshot<DocumentData>) => {
          statuses.push(Status.mapFromFirestore(document.data(), document.id));
        });
        return statuses;
      }));
  }

  createStatus(status: Status, practitioner: Practitioner, detail?: string): Promise<Status> {
    return new Promise<Status>((resolve, reject) => {
      let updatedStatus = status.value === PractitionerStatus.ApprovedConditionally ? PractitionerStatus.Approved : status.value;
      this.firestore.collection('practitioners').doc(status.practitionerId).update({ status: updatedStatus });
      this.firestore.collection('practitioners').doc(status.practitionerId).collection('statuses').add(status.mapToFirestore())
        .then((docRef: DocumentReference) => {
          this._sendEmail(status, practitioner, detail);
          status.id = docRef.id;
          resolve(status);
        }, _ => {
          reject('There was an error requesting your booking.');
        });
    });
  }

  private _sendEmail(status: Status, practitioner: Practitioner, detail?: string) {
    switch(status.value) {
      case PractitionerStatus.Approved:
        this.mailService.sendPractitionerApprovedEmail(practitioner);
        break;
      case PractitionerStatus.Rejected:
        this.mailService.sendPractitionerRejectedEmail(practitioner);
        break;
      case PractitionerStatus.ApprovedConditionally:
        this.mailService.sendPractitionerApprovedConditionallyEmail(practitioner, detail);
        break;
    }
  }
}
